// extracted by mini-css-extract-plugin
module.exports = {"block":"index_block_24sW6","inner":"index_inner_3RE_Q","form":"index_form_G85vg"};